import type { HydraContext } from '@composables/common'

export enum UserRole {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
}

export interface UserHydraItem extends HydraContext {
  name: string
  username: string
  tokenExpiresAt: string
  roles: UserRole[]
  thirdPartyIdentifier: string
  id: number
}
